import Vue from 'vue';

class EventBus {
  constructor() {
    this.init(Vue);
  }

  init(Vue) {
    this.vue = new Vue();
  }

  fire(event, data = null, data2 = null) {
    this.vue.$emit(event, data, data2);
  }

  listen(event, cb) {
    this.vue.$on(event, cb);
  }

  destroy(event, cb) {
    this.vue.$off(event, cb);
  }
}

export default new EventBus();
